import { render } from "./InlineNotes.vue?vue&type=template&id=1aa66170&scoped=true&ts=true&lang=html"
import script from "./InlineNotes.vue?vue&type=script&lang=ts"
export * from "./InlineNotes.vue?vue&type=script&lang=ts"

import "./InlineNotes.vue?vue&type=style&index=0&id=1aa66170&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa66170"]])

export default __exports__